import { ActivityLog, OffsetLimitPagination } from 'types';
import { CapitolaClient } from './base';

export type ActivityLogQuery = OffsetLimitPagination;
export class ActivityLogClient extends CapitolaClient<ActivityLog> {
  public get resourceName(): string {
    return 'activity-log';
  }
}
